import { defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { committedUnitTarget, liveAlliedFieldCard } from './furniture_helpers.js';
export const SpringCleaningCard = defineGameCard({
    id: 'spring_cleaning',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'ally',
                cardTypes: ['STRUCTURE'],
                cardinality: { min: 1, max: 1 },
                where: ({ unit, context }) => unit.controllerId === context.viewerId,
            })),
        ]),
    },
    presentation: {
        name: 'Генеральная уборка',
        description: 'Выберите свою Структуру и уничтожьте её. Затем возьмите 2 карты.',
        glyph: {
            colors: ['#10213A', '#3D716C', '#246F69', '#9BAD87', '#83593F'],
            rows: [
                '....................',
                '....................',
                '........1111........',
                '.....1112222111.....',
                '....132222222231....',
                '....134444444431....',
                '....133333332331....',
                '....133331133231....',
                '....1233333333321...',
                '..1122133333312211..',
                '.131211244442112331.',
                '.122122111111221221.',
                '.1322221.11.1222231.',
                '.4111111.55.1111114.',
                '.144545.151..54544..',
                '........5551........',
                '......155..54.......',
                '........5.5.1.......',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = committedUnitTarget(ctx);
            const controllerId = ctx.self?.controllerId;
            if (targetId === undefined || controllerId === undefined)
                return;
            const target = liveAlliedFieldCard(ctx, targetId, controllerId);
            if (target === undefined || ctx.q.cardType(target.id) !== 'STRUCTURE')
                return;
            ctx.ops.destroy(target.id);
            ctx.ops.drawCard(controllerId, 2);
        }),
    ],
    ui: {
        mechanics: ['death'],
        planning: {
            steps: { target: { label: 'Выберите свою Структуру' } },
        },
    },
});
//# sourceMappingURL=spring_cleaning.js.map